import { FunctionComponent } from "react";

import {
  ChoiceComboBox,
  ChoiceComboBoxProps,
  Stack,
  useFieldContext,
  useFieldRegister
} from "@bps/fluent-ui";

type FormChoiceComboBoxProps = Omit<
  ChoiceComboBoxProps,
  "multiSelect" | "selectedKey" | "data-name-for-input" | "onChange" | "styles"
> & {
  name: string;
};

export const FormChoiceComboBox: FunctionComponent<FormChoiceComboBoxProps> = ({
  name,
  options,
  ...props
}) => {
  useFieldRegister(name);
  const { value, setFieldValue } = useFieldContext<string>(name);

  return (
    <Stack styles={{ root: { width: "100%", height: "100%" } }}>
      <ChoiceComboBox
        data-name-for-input={name}
        allowFreeform
        autoComplete="on"
        multiSelect={false}
        selectedKey={value!}
        onChange={(evt, options) => setFieldValue(options.key!)}
        options={options}
        {...props}
      />
    </Stack>
  );
};
